import { render, staticRenderFns } from "./CollapsableItemContainer.vue?vue&type=template&id=464b5dc8&scoped=true&"
import script from "./CollapsableItemContainer.vue?vue&type=script&lang=js&"
export * from "./CollapsableItemContainer.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableItemContainer.vue?vue&type=style&index=0&id=464b5dc8&scoped=true&lang=css&"
import style1 from "./CollapsableItemContainer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464b5dc8",
  null
  
)

export default component.exports